import { currencyFilter } from '@/utils/filters';

export default {
    props: {
        packageBalances: Array,
        customPackageArr: Array,
        isMobile: Boolean
    },
    name: 'BalanceCard',
    data: () => ({
        packageDetails: {
            name: '',
            details: []
        },
        selectedPackage: '',
        isCustomPackage: false,
        customPackage: {
            transactionValue: '0',
            bonusValue: '0',
            totalValue: '0',
            isCustom: true,
            customPackage: ''
        },
        errorMessage: '',
        inputError: false
    }),
    mounted() {
        (this.packageDetails.name = this.packageBalances[0].name),
        (this.packageDetails.details = this.setPackageDetailsList(this.packageBalances[0].description));
        this.selectedPackage = this.packageBalances[0].id;
        this.customPackage = {...this.customPackageArr[0]}
        this.$emit('setPackageBalance', this.packageBalances[0])
    },
    methods: {
        currencyFilter,
        goToLightboxCheckoutPage(balancePackage) {
            this.$emit('goToLightboxCheckoutPage', balancePackage);
        },
        setActive(packageBalance) {
            this.isCustomPackage = false;
            this.customPackage.transactionValue = '0'
            this.packageDetails.name = packageBalance.name;
            this.packageDetails.details = this.setPackageDetailsList(packageBalance.description);
            this.setBonusToRecive();
            this.$emit('setPackageBalance', packageBalance);
            this.$emit('invalidPackage', false);
        },
        setCustomPackage() {
            this.isCustomPackage = true;
            this.$emit('setPackageBalance', this.customPackage);
            this.$emit('invalidPackage', true);
        },
        setPackageDetailsList(string) {
            const arr = string.split(/(?:\r\n|\r|\n)/g);
            return arr;
        },
        async checkValue(value) {
            this.inputError = !this.inputError
            if(value < 900.00) {
                this.errorMessage = 'O valor mínimo é de R$900,00'
                this.$emit('invalidPackage', true);
            } else {
                this.errorMessage = ''
                this.$emit('setPackageBalance', this.customPackage);
                this.$emit('invalidPackage', false);
            }
        },
        async setBonusToRecive() {
            // eslint-disable-next-line no-useless-escape
            this.customPackage.transactionValue = this.customPackage.transactionValue.slice(0,-3).replace(/\./g, '') + '.00';
            const str = this.customPackage.transactionValue
            const value = parseFloat(str)
            const bonus = value * 0.30;
            const total = bonus + value
            this.customPackage.totalValue = total.toFixed(2).toString();
            this.customPackage.bonusValue = bonus.toFixed(2).toString();
            this.customPackage.description = `Você receberá no total ${this.customPackage.totalValue} moedas.`
            await this.checkValue(value)
        }
    },
};
